import { FC } from 'react';
import Link from 'next/link';
import { IBookDetailSeriesData } from '@/interfaces/bookDetail.interface';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { hideImgOnError } from '@/helpers/helpers';
import styles from './BookSeries.module.scss';
import { IBookShortDetailSeries } from '@/interfaces/bookShortDetail.interface';

interface IBookSeriesProps {
  series: IBookShortDetailSeries[];
}

const BookSeries: FC<IBookSeriesProps> = ({ series }) => {
  return (
    <div className={styles.bookSeries}>
      <div className={styles.bookSeries__title}>Серия «{series[0].title}»</div>
      <div className={styles.bookSeries__list}>
        {series[0].other_series_books.map((item, index) =>
          index < 3 ? (
            <div className={styles.bookSeries__item} key={item.book_id}>
              <Link prefetch={false} className={styles.bookSeries__imgWrap} href={`/book/${item.book_id}`}>
                <img className={styles.bookSeries__img} src={`${DEV_ABSOLUTE_URL}/covers/${item.external_id}.jpg`} alt="img" onError={hideImgOnError} />
              </Link>
              <Link prefetch={false} className={styles.bookSeries__bookTitle} href={`/book/${item.book_id}`}>
                {item.title}
              </Link>
            </div>
          ) : null
        )}
      </div>
      {/* <Link prefetch={false} className={styles.bookSeries__btn} href={`/series/${series[0].id}/`}>
        Все книги серии
      </Link> */}
    </div>
  );
};
export default BookSeries;
